import {fromJS, Map} from 'immutable';
import talonActions from '../../actions/talon.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TalonState} from './types';

const initialState: TalonState = {
    loading: false,
    solveToken: null,
    flowId: null
};

export const DEFAULT_STATE = fromJS(initialState);

export const talonReducer = (state: Map<keyof TalonState, any> = DEFAULT_STATE, action) => {
    const newState = state;
    switch (action.type) {
        case talonActions.TYPES.START_TALON_COMPLETE: {
            return newState.updateIn(['loading'], () => true);
        }

        case talonActions.TYPES.UPDATE_SOLVE_TOKEN: {
            return newState.updateIn(['loading'], () => true);
        }
        case talonActions.TYPES.UPDATE_SOLVE_TOKEN_COMPLETE: {
            const {solveToken} = action.payload;
            return newState.merge({
                loading: false,
                solveToken
            });
        }
        case talonActions.TYPES.UPDATE_SOLVE_TOKEN_FAILED: {
            return newState.merge({
                loading: false,
                solveToken: null
            });
        }

        case talonActions.TYPES.RESET_TALON_COMPLETE: {
            return newState.merge({
                loading: false,
                solveToken: null
            });
        }

        default:
            return newState;
    }
};

export default dieselReducer('talon', talonReducer);
